import { getExternalVATRates } from 'client/api/accounting'
import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { type CompanyInterface, UiSetup } from 'client/Interfaces/CompanyInterface'
import { type SettingsInterface } from 'client/Interfaces/Settings/SettingsInterface'
import { hasModuleAvailable, moduleNames } from 'client/reducers/settings'
import dayjs from 'dayjs'

type betaAccessGroup = 'Group 1' | 'Group 2' | 'Not Eligible'
export const getBetaAccessGroup = (company: CompanyInterface): betaAccessGroup => {
  const { country, agerasNextMigration, uiSetup, randomBucket, email } = company
  const isNotYetMigrated = !agerasNextMigration || uiSetup === UiSetup.Invoicing
  if (country === 'FR' && isNotYetMigrated && randomBucket >= 0 && email) {
    if (email.includes('+status1+')) {
      return 'Group 1'
    }

    const isCorrectRandomBucketGroup = randomBucket <= 11 && window.localStorage.getItem('WelcomeModal') === 'true'
    if (email.includes('+status2+') || isCorrectRandomBucketGroup) {
      return 'Group 2'
    }
  }
  return 'Not Eligible'
}

export const getAccountingConnectionStatus = (company: CompanyInterface, settings: SettingsInterface): string => {
  const accessStatus = getBetaAccessGroup(company)
  const isNotYetMigrated = !company?.agerasNextMigration || company?.uiSetup === UiSetup.Invoicing
  if (isNotYetMigrated && accessStatus !== 'Group 2') {
    const isEnabled = hasModuleAvailable(settings, moduleNames.agerasAccounting) || accessStatus === 'Group 1'
    if (isEnabled) {
      return 'enabled'
    }
    return 'not_allowed'
  }
  return 'activated'
}

export const getAccessGroupTwoWithDate = (company: CompanyInterface, userCreationDate: number | string) => {
  const hardcodedNavBarStart = new Date('2024-04-18:14:00') // Beta release date. Do not involve users before this date
  return (
    company && getBetaAccessGroup(company) === 'Group 2' && new Date(Number(userCreationDate)) > hardcodedNavBarStart
  )
}

const requestVatRateWithPause = async (delay: number, syncStartDate: dayjs.Dayjs) => {
  await new Promise((resolve) => setTimeout(resolve, delay))
  const result = await getExternalVATRates()

  const now = dayjs()
  Segment.track(SegmentEvents.loader.newTimeout, {
    delay: now.diff(syncStartDate, 'seconds'),
  })

  if (result) {
    Segment.track(SegmentEvents.loader.syncOver, {
      delay: now.diff(syncStartDate, 'seconds'),
      result: 'success',
    })
  }

  return result
}

export const signupDelay = async (company: CompanyInterface): Promise<void> => {
  const syncStartDate = dayjs()

  if (
    company?.country !== 'FR' ||
    !company?.agerasNextMigration ||
    company?.uiSetup === UiSetup.Invoicing ||
    company?.externalOrganisationId ||
    !window.localStorage.WelcomeModal
  ) {
    return
  }

  Segment.track(SegmentEvents.loader.syncStart)

  if (await requestVatRateWithPause(3000, syncStartDate)) {
    return
  }
  if (await requestVatRateWithPause(3000, syncStartDate)) {
    return
  }
  if (await requestVatRateWithPause(4000, syncStartDate)) {
    return
  }
  if (await requestVatRateWithPause(5000, syncStartDate)) {
    return
  }

  const now = dayjs()
  Segment.track(SegmentEvents.loader.syncOver, {
    delay: now.diff(syncStartDate, 'seconds'),
    result: 'fail',
  })
}
